import "./css/normalize.css"; //CSS reset
import "./css/site.css";

import React from "react";
import { Route, Routes } from "react-router-dom";

import { ROUTES } from "../data/content";
import ScrollToTop from "./general/ScrollToTop";
import Header from "./layout/Header";
import Footer from "./layout/Footer";
import Home from "./home/Home";
import About from "./about/About";
import Services from "./services/Services";
import Rooms from "./rooms/Rooms";
import Events from "./events/Events";
import Gallery from "./gallery/Gallery";
import Contact from "./contact/Contact";
import Menus from "./menus/Menus";
import NotFound from "./general/NotFound";

const PAGES = [
  { path: ROUTES.HOME, Page: Home },
  { path: ROUTES.ABOUT, Page: About },
  { path: ROUTES.SERVICES, Page: Services },
  { path: ROUTES.ROOMS, Page: Rooms },
  { path: ROUTES.EVENTS, Page: Events },
  { path: ROUTES.GALLERY, Page: Gallery },
  { path: ROUTES.CONTACT, Page: Contact },
  { path: ROUTES.MENUS, Page: Menus },
];

const App = () => {
  return (
    <React.Fragment>
      <a
        className={"skip-link"}
        href={"#main"}
        onClick={(e) => {
          e.preventDefault();
          document.getElementById("main").focus();
        }}
      >
        Skip to main content
      </a>
      <ScrollToTop />
      <Header />
      <main
        id={"main"}
        className={"site-main"}
        tabIndex={-1}
      >
        <Routes>
          {PAGES.map(({ path, Page }) => (
            <Route
              key={path}
              path={path}
              element={<Page />}
            />
          ))}
          <Route
            path={"*"}
            element={<NotFound />}
          />
        </Routes>
      </main>
      <Footer />
    </React.Fragment>
  );
};

export default App;
